const launch = {
  id: 'cheese',
  address: {
    56: '0x218857fff035cebb6fdd390084a21b77f7a0f6da',
    97: '0x8E3Be059992dee2a668902EED64bac9Bab134071',
  },
  isActive: true,
  symbol: 'CHEESE',
  name: 'Cheese Token',
  currency: 'BNB',
  presaleAddress: '0x19b8dd854fE7A3933D5DD75daed988702bdb7549',
  tokenDecimals: 18,
  maxContribution: '10',
  minContribution: '1',
  soft: 4000,
  hard: 20000,
  price: 0.01,
}

export default launch